import type { PropsWithChildren } from "react";
import { twMerge } from "tailwind-merge";

import type { Styled } from "~/utils";

export const ErrorLabel = ({
  children,
  className,
}: PropsWithChildren<Styled>) => (
  <span className={twMerge("mt-1 text-xs text-error-70", className)}>
    {children}
  </span>
);
